if (!window.__quickAddInit) {
        window.__quickAddInit = true;
    var openList = null;
    var openToggle = null;
    function closeOpenQuickAdd() {
      if (openList) openList.setAttribute('hidden', '');
      if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
      openList = null;
      openToggle = null;
    }
    window.addEventListener('scroll', function (ev) {
      if (!openList) return;
      if (ev.target && ev.target.closest && ev.target.closest('[data-quick-add-list]')) return;
      closeOpenQuickAdd();
    }, { capture: true, passive: true });
    document.addEventListener('change', function (e) {
      var select = e.target && e.target.closest ? e.target.closest('[data-quick-add-select]') : null;
      if (!select) return;
      var form = select.closest('form');
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = select.value;
      }
      var card = select.closest('.product-item');
      var opt = select.options[select.selectedIndex];
      if (card && opt) {
        var priceList = card.querySelector('.product-item__price-list');
        if (priceList) {
          if (opt.dataset.comparePrice) {
            priceList.innerHTML = '<span class="price price--highlight">' + opt.dataset.price + '</span> <span class="price price--compare">' + opt.dataset.comparePrice + '</span>';
          } else {
            priceList.innerHTML = '<span class="price">' + opt.dataset.price + '</span>';
          }
        }
        var label = card.querySelector('[data-quick-add-label]');
        if (label) {
          if (opt.dataset.label) { label.textContent = opt.dataset.label; label.style.display = ''; }
          else { label.textContent = ''; label.style.display = 'none'; }
        }
        if (opt.dataset.image) {
          var img = card.querySelector('.product-item__primary-image') || card.querySelector('.product-item__image-wrapper img') || card.querySelector('img');
          if (img) {
            img.src = opt.dataset.image;
            if (img.hasAttribute('srcset')) img.setAttribute('srcset', opt.dataset.image);
            if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset', opt.dataset.image);
            if (img.hasAttribute('data-src')) img.setAttribute('data-src', opt.dataset.image);
          }
        }
      }
    });
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest ? e.target.closest('[data-quick-add-toggle]') : null;
      if (toggle) {
        var qa = toggle.closest('[data-quick-add]');
        var list = qa.querySelector('[data-quick-add-list]');
        var isOpen = !list.hasAttribute('hidden');
        closeOpenQuickAdd();
                if (!isOpen) { var tr = toggle.getBoundingClientRect(); list.style.top = (tr.bottom + 6) + 'px'; list.style.left = tr.left + 'px'; list.style.width = tr.width + 'px'; list.removeAttribute('hidden'); toggle.setAttribute('aria-expanded', 'true'); openList = list; openToggle = toggle; }
        return;
      }
      var optEl = e.target.closest ? e.target.closest('.quick-add__option') : null;
      if (optEl && !optEl.classList.contains('is-disabled')) {
        var qa2 = optEl.closest('[data-quick-add]');
        var sel = qa2.querySelector('[data-quick-add-select]');
        sel.value = optEl.dataset.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        var tt = qa2.querySelector('[data-quick-add-toggle-text]');
        var inner = optEl.querySelector('.quick-add__option-inner');
        if (tt && inner) tt.innerHTML = inner.innerHTML;
        qa2.querySelectorAll('.quick-add__option').forEach(function (li) { li.classList.remove('is-selected'); });
        optEl.classList.add('is-selected');
        var l2 = qa2.querySelector('[data-quick-add-list]');
        if (l2) l2.setAttribute('hidden', '');
        var t2 = qa2.querySelector('[data-quick-add-toggle]');
        if (t2) t2.setAttribute('aria-expanded', 'false');
        return;
      }
      if (!e.target.closest || !e.target.closest('[data-quick-add]')) {
        closeOpenQuickAdd();
      }
    });
  }
